<template>
  <div class="image-carousel">
    <swiper
      class="position-relative image-carousel__slider"
      add_navigation_buttons
      next_btn_class="image_next_btn"
      prev_btn_class="image_prev_btn"
      has_pagination
      :class="{nav_buttons_inside: nav_buttons_inside_block}"
      :swiper_config="swiper_config"
      :swiper_events="swiper_events"
      :breakpoints="swiper_breakpoints">
      <swiper-slide
        v-for="(image, index) in images"
        class="image-carousel__slider-slide"
        :key="`image-carousel-slide_${index}_${uid}`">
        <template v-if="lazy_carousel">
          <lazy-image
            v-if="!index || slide_index_shown.includes(index)"
            :src="image.image_src"
            cover_img
            class="image-carousel__slider-image"
            :lazy_src="image.image_lazy_src"
            :alt="`article image ${index}`"/>
          <div
            v-else
            class="lazy-image cover_img">
            <img
              :src="image.image_src"
              class="lazy-image_thumb thumbs_lazy"
              :alt="`article image ${index}`"/>
          </div>
        </template>
        <template v-else>
          <lazy-image
            :src="image.image_src"
            :img_border_radius="img_border_radius"
            cover_img
            class="image-carousel__slider-image"
            :lazy_src="image.image_lazy_src"
            alt="article image"/>
        </template>

      </swiper-slide>
    </swiper>
  </div>
</template>

<script>

import Swiper from "../modules/Swiper/Swiper.vue";
import SwiperSlide from "../modules/Swiper/SwiperSlide.vue";
import LazyImage from "../small_parts/LazyImage.vue";
import uid_mixin from "../../mixins/uid_mixin";

export default {
  name: "FullWidthImageCarousel",
  mixins: [uid_mixin],
  components: {
    LazyImage,
    SwiperSlide,
    Swiper
  },
  props: {
    images: {
      type: Array,
      default: () => [],
    },
    swiper_breakpoints: {
      type: Object,
      default: () => {},
    },
    swiper_config: {
      type: Object,
      default: () => {},
    },
    img_border_radius: {
      type: Boolean,
      default: true,
    },
    nav_buttons_inside_block: {
      type: Boolean,
      default: false,
    },
    lazy_carousel: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    swiper_events() {
      if (!this.lazy_carousel) return null
      return {
        realIndexChange: this.slideChanged,
      }
    },
  },
  data() {
    return {
      active_slide_index: 0,
      slide_index_shown: [0],
    }
  },
  methods: {
    slideChanged({realIndex = 0}) {
      if (this.active_slide_index === realIndex) return
      this.active_slide_index = realIndex
      if (this.slide_index_shown.includes(realIndex)) return;
      this.slide_index_shown.push(realIndex)
    },
  }
}
</script>
